import React, { useState } from 'react'
import classnames from 'classnames'
import { Grid } from 'antd'
const { useBreakpoint } = Grid

/**
 * @name RadioSelector
 *
 * @description
 * ...
 */
const RadioSelector = ({
  svgIcon,
  label,
  onClick,
  value,
  isSelected,
  justify = 'center',
}) => {
  const [hovered, setHovered] = useState(false)
  const screens = useBreakpoint()
  const classes = {
    wrapper: classnames(
      `radio-item-custom flex flex-col items-${justify} justify-center font-semibold text-lg cursor-pointer text-center`,
      {
        'text-primary': isSelected,
      }
    ),
    icon: classnames(
      'rounded-full border border-gray-600 p-2 sm:p-4 md:p-4 border-solid flex items-center justify-center text-sm',
      {
        'border-primary': isSelected,
      }
    ),
    label: `pt-1 md:pt-2 text-sm md:text-lg flex flex-col items-${justify}`,
  }
  return (
    <div
      className={classes.wrapper}
      {...(screens.sm ? null : {
        onMouseEnter: () => setHovered(true),
        onMouseLeave: () => setHovered(false)
      })}
      onClick={() => {
        setHovered(!hovered)
        if (onClick) {
          onClick()
        }        
      }}
    >
      <div className={classes.icon}>{svgIcon}</div>
      {label && <div className={classes.label}>{label}</div>}
    </div>
  )
}

export default RadioSelector
